<script setup lang="ts">
import { requestState } from './api/request-state';
import { useMobileViewport } from './composables/useMobileViewport';
import { Button } from '@/components/ui/button';
useMobileViewport();
import { RouterView } from 'vue-router';
import { Toaster } from '@/components/ui/sonner';
</script>

<template>
  <div
    v-if="requestState.pending"
    role="status"
    class="pointer-events-none fixed left-1/2 top-2 z-[100] -translate-x-1/2 rounded-md bg-primary px-3 py-2 text-sm text-primary-foreground"
  >
    正在加载…
  </div>
  <div
    v-if="requestState.error"
    role="alert"
    class="fixed inset-x-4 top-14 z-[100] mx-auto flex max-w-lg items-center justify-between gap-2 rounded-md border border-destructive bg-background p-3 text-sm"
  >
    <span>{{ requestState.error }}</span>
    <Button
      variant="outline"
      class="h-touch shrink-0"
      aria-label="关闭请求失败提示"
      @click="requestState.error = ''"
    >
      关闭
    </Button>
  </div>
  <RouterView />
  <Toaster
    position="top-center"
    rich-colors
  />
</template>
